import React from 'react';

import dopamineNation from '../dopamineNation';
import NotePage from '../../pages/NotePage';

const notes = [
  "- Finding balance in the Age of Indulgence",
  "Introduction",
  "The problem",
  "- We’ve transformed the world from a place of scarcity to a place of overwhelming abundance",
  "Part 1: The Pursuit of Pleasure",
  "Chapter 1: Our Masturbation Machines",
  "- Addiction is the continued and compulsive consumption of a substance or behavior despite its harm to self and/or others",
  "- One of the biggest risk factors for getting addicted to any drug is easy access to that drug",
  "- The positive impact of prohibition on alcohol consumption and related morbidity is widely underrecognized",
  "- Human beings are social animals. When we see others behaving in a certain way online, those behaviors seem “normal” because other people are doing them",
  "Chapter 2: Running from Pain",
  "- We’ve lost the ability to tolerate even minor forms of discomfort. We’re constantly seeking to distract ourselves from the present moment, to be entertained",
  "Chapter 3: The Pleasure-Pain Balance",
  "- What goes up must come down",
  "- Every pleasure exacts a price, and the pain that follows is longer lasting and more intense than the pleasure that gave rise to it",
  "- Our brains are not evolved for this world of plenty",
  "Part 2: Self-Binding",
  "Chapter 4: Dopamine Fasting",
  "- DOPAMINE",
  "	- D = Data",
  "		- The simple facts of consumption",
  "		- What you are using, how much, and how often",
  "	- O = Objectives.",
  "		- What does it do for you?",
  "		- Objectives for using",
  "		- Even seemingly irrational behavior is rooted in some personal logic",
  "	- P = Problems",
  "		- High-dopamine drugs always lead to problems. Health problems, relationship problems, moral problem. If not right away, then eventually",
  "	- A = Abstinence",
  "		- Stop using for a month. At first you’ll feel worse due to withdrawal. But if you can get through the first two weeks, there’s a good chance that in the second two weeks you’ll start feeling better",
  "		- Consider your current behavior in light of your future self",
  "		- At two weeks, patients are usually still experiencing withdrawal. They are still in a dopamine deficit state",
  "		- 20% or patients don’t feel better after a dopamine fast",
  "		- The drug wasn’t the main driver of the psychiatric drug",
  "	- M = Mindfulness",
  "		- Observe the mind without judgement",
  "		- Staying in the observer position is essential to getting to know our brains and ourselves in a new way",
  "	- I = Insight",
  "		- Abstaining from our drug of choice for at least four weeks gives clarifying insight into our behaviors",
  "	- N = next steps",
  "		- Decide how you want to proceed",
  "	- E = experiment",
  "Chapter 5: Space, Time, and Meaning",
  "- Self-binding is intentionally and willingly creating barriers between ourselves and our drug of choice in order to mitigate compulsive overconsumption",
  "- Let your feelings crest over you like a wave. Be patient, and with time, you will feel better",
  "- Binding ourselves is a way to be free",
  "Chapter 6: A Broken Balance?",
  "- Any drug that presses on the pleasure side has the potential to be addictive",
  "Part 3: The Pursuit of Pain",
  "Chapter 7: Pressing on the Pain Side",
  "- We have to remember that we will feel pleasure after pain, and we’re remarkably amnestied about this sort of thing",
  "Chapter 8: Radical Honesty",
  "- Lying in a world of plenty risks isolation, craving, and pathological overconsumption",
  "- Radical honesty promotes awareness of our actions, fosters intimate human connections, leads to a truthful autobiography, which holds us accountable not just to our present but also to our future selves, and is contagious",
  "- What behavior do you want to change?",
  "- Why do you want to make that change?",
  "- What would you be giving up if you stopped that behavior?",
  "- What is one step you can take to change that behavior?",
  "- Telling the truth draws people in, especially when we’re willing to expose our own vulnerabilities. They see in our brokenness their own vulnerability and humanity. They are reassured that they are not alone in their doubts, fears, and weaknesses",
  "- Consuming leads to isolation and indifference, as the drug comes to replace the reward obtained from being in relationship with others",
  "- Patients who tell stories in which they are frequently the victim, seldom bearing responsibility for bad outcomes, are often unwell and remain unwell",
  "- I am responsible",
  "- Truth-telling engenders a plenty mindset. Lying engenders a scarcity mindset",
  "- Parents who stop smoking pot are followed by children who do the same",
  "- When the people around us are reliable and tell us the truth, including keeping promises they’ve made to us, we feel more confident about the world and our own future in it",
  "- When resources are scare, people are more invested in immediate gains, and are less confident that those rewards will still be forthcoming in some distant future",
  "- The feeling of plenty comes from a source beyond the material world",
  "- Believing in or working toward something outside ourselves, and fostering a life rich in human connectedness and meaning, can function as social glue by giving us a plenty mindset even in the midst of abject poverty",
  "Chapter 9: Prosocial Shame",
  "- Shame makes us feel bad about ourselves as people, whereas guilt makes us feel bad about our actions while preserving a positive sense of self",
  "- We are all flawed, capable of making mistakes, and in need of forgiveness",
  "- Instead of getting frustrated, how can you help them get what they need?",
  "- When we’re accountable to ourselves, we’re able to hold others accountable",
  "- It is not our perfection but our willingness to work together to remedy our mistakes that creates the intimacy we crave",
  "Conclusion: Lessons of the Balance",
  "- Find a way to immerse yourself fully in the life that you’ve been given",
  "- The world is something worth paying attention to",
  "- The rewards of finding and maintaining balance are neither immediate nor permanent. They require patience and maintenance. We must have faith that actions today that seem to have no impact in the present moment are in fact accumulating in a positive direction, which will be revealed to us only at some unknown time in the future",
  "- Healthy practices happen day by day",
  "- Lessons of the balance",
  "	1. The relentless pursuit of pleasure (and avoidance of pain) leads to pain",
  "	2. Recovery begins with abstinence",
  "	3. Abstinence resets the brains reward pathway and with it our capacity to take joy in simpler pleasures",
  "	4. Self-binding creates literal and meta cognitive space between desire and consumption, a modern necessity in our dopamine-overloaded world",
  "	5. Medications can restore homeostasis, but consider what we lose by medicating away our pain",
  "	6. Pressing on the pain side resets our balance to the side of pleasure",
  "	7. Beware of getting addicted to pain",
  "	8. Radical honesty promotes awareness, enhances intimacy, and fosters a plenty mindset",
  "	9. Pro social shake affirms that we belong to the human tribe",
  "	10. Instead of running away from the world, we can find escape by immersing ourselves in it",

  "#SharedFromTwos ✌️",
];

const DopamineNation = props => <NotePage notes={notes} list={dopamineNation} {...props} />;

export default DopamineNation;
